import _toConsumableArray from "/var/www/primes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/var/www/primes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/www/primes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { IS_PROXY, VALUE, PATH, Proxifier, CACHED_PROXY } from './Proxyfier';
import isPlainObject from 'is-plain-obj';
import { MutationTree } from './MutationTree';
import { TrackStateTree } from './TrackStateTree';
export { IS_PROXY, VALUE, PATH, CACHED_PROXY, TrackStateTree, MutationTree };
export var ProxyStateTree =
/*#__PURE__*/
function () {
  function ProxyStateTree(state) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, ProxyStateTree);

    this.removeProxyCallbacks = [];
    this.cache = {
      mutationTree: [],
      trackStateTree: []
    };
    this.flushCallbacks = [];
    this.mutationCallbacks = [];
    this.currentFlushId = 0;
    this.pathDependencies = {};

    if (!isPlainObject(state)) {
      throw new Error('You did not pass a plain object as state to Proxy State Tree');
    }

    if (typeof options.devmode === 'undefined') {
      options.devmode = true;
    }

    this.master = this;
    this.sourceState = state;
    this.options = options;
    this.createTrackStateProxifier();
  }
  /*
    We create a base proxifier for tracking state. That means there is one
    proxifier for all track state trees. This works because the actual tracking
    refers to the current tree on "master"
  */


  _createClass(ProxyStateTree, [{
    key: "createTrackStateProxifier",
    value: function createTrackStateProxifier() {
      var trackStateTree = new TrackStateTree(this);
      this.proxifier = trackStateTree.proxifier = new Proxifier(trackStateTree);
      this.state = trackStateTree.state = this.proxifier.proxify(this.sourceState, '');
    }
  }, {
    key: "onRemoveProxy",
    value: function onRemoveProxy(cb) {
      var _this = this;

      var index = this.removeProxyCallbacks.push(cb) - 1;
      return function () {
        _this.removeProxyCallbacks.splice(index, 1);
      };
    }
  }, {
    key: "removeProxy",
    value: function removeProxy(path) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.removeProxyCallbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var cb = _step.value;
          cb(path);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "getMutationTree",
    value: function getMutationTree() {
      if (!this.options.devmode) {
        return this.mutationTree = this.mutationTree || new MutationTree(this, this.proxifier);
      }

      var tree = this.cache.mutationTree.pop() || new MutationTree(this);
      return tree;
    }
  }, {
    key: "getTrackStateTree",
    value: function getTrackStateTree() {
      return this.cache.trackStateTree.pop() || new TrackStateTree(this);
    }
  }, {
    key: "getTrackStateTreeWithProxifier",
    value: function getTrackStateTreeWithProxifier() {
      var tree = this.getTrackStateTree();
      tree.proxifier = new Proxifier(tree);
      tree.state = tree.proxifier.proxify(this.sourceState, '');
      return tree;
    }
  }, {
    key: "changeTrackStateTree",
    value: function changeTrackStateTree(tree) {
      this.previousTree = this.currentTree;
      this.currentTree = tree;
    }
  }, {
    key: "disposeTree",
    value: function disposeTree(tree) {
      if (tree instanceof MutationTree) {
        this.cache.mutationTree.push(tree.dispose());
      } else if (tree instanceof TrackStateTree) {
        this.cache.trackStateTree.push(tree.dispose());

        if (tree.proxifier !== this.proxifier) {
          tree.proxifier.dispose();
        }

        tree.proxifier = this.proxifier;
      }
    }
  }, {
    key: "onMutation",
    value: function onMutation(callback) {
      var _this2 = this;

      this.mutationCallbacks.push(callback);
      return function () {
        return _this2.mutationCallbacks.splice(_this2.mutationCallbacks.indexOf(callback), 1);
      };
    }
  }, {
    key: "forceFlush",
    value: function forceFlush() {
      var _this3 = this;

      var emptyMutations = [];
      var emptyPaths = new Set();

      for (var key in this.pathDependencies) {
        var callbacks = this.pathDependencies[key];
        callbacks.forEach(function (callback) {
          callback(emptyMutations, emptyPaths, _this3.currentFlushId++, false);
        });
      }
    }
  }, {
    key: "flush",
    value: function flush(trees) {
      var isAsync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var changes;

      if (Array.isArray(trees)) {
        changes = trees.reduce(function (aggr, tree) {
          return {
            mutations: aggr.mutations.concat(tree.getMutations()),
            objectChanges: new Set([].concat(_toConsumableArray(aggr.objectChanges), _toConsumableArray(tree.getObjectChanges())))
          };
        }, {
          mutations: [],
          objectChanges: new Set()
        });
      } else {
        changes = {
          mutations: trees.getMutations(),
          objectChanges: trees.getObjectChanges()
        };
      }

      if (!changes.mutations.length && !changes.objectChanges.size) {
        return {
          mutations: [],
          flushId: null
        };
      }

      var paths = new Set();
      var pathCallbacksToCall = new Set();
      var flushId = this.currentFlushId++;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = changes.objectChanges[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var objectChange = _step2.value;

          if (this.pathDependencies[objectChange]) {
            paths.add(objectChange);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = changes.mutations[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var mutation = _step3.value;
          paths.add(mutation.path);
        } // Sort so that parent paths are called first

      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var sortedPaths = Array.from(paths).sort();
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = sortedPaths[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var path = _step4.value;

          if (this.pathDependencies[path]) {
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
              for (var _iterator7 = this.pathDependencies[path][Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                var callback = _step7.value;
                pathCallbacksToCall.add(callback);
              }
            } catch (err) {
              _didIteratorError7 = true;
              _iteratorError7 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
                  _iterator7.return();
                }
              } finally {
                if (_didIteratorError7) {
                  throw _iteratorError7;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = pathCallbacksToCall[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _callback = _step5.value;

          _callback(changes.mutations, sortedPaths, flushId, isAsync);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = this.flushCallbacks[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var _callback2 = _step6.value;

          _callback2(changes.mutations, sortedPaths, flushId, isAsync);
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      paths.clear();
      pathCallbacksToCall.clear();
      return {
        mutations: changes.mutations,
        flushId: flushId
      };
    }
  }, {
    key: "onFlush",
    value: function onFlush(callback) {
      var _this4 = this;

      this.flushCallbacks.push(callback);
      return function () {
        return _this4.flushCallbacks.splice(_this4.flushCallbacks.indexOf(callback), 1);
      };
    }
  }, {
    key: "rescope",
    value: function rescope(value, tree) {
      return value && value[IS_PROXY] ? tree.proxifier.proxify(value[VALUE], value[PATH]) : value;
    }
  }, {
    key: "addPathDependency",
    value: function addPathDependency(path, callback) {
      if (!this.pathDependencies[path]) {
        this.pathDependencies[path] = new Set();
      }

      this.pathDependencies[path].add(callback);
    }
  }, {
    key: "removePathDependency",
    value: function removePathDependency(path, callback) {
      this.pathDependencies[path].delete(callback);

      if (!this.pathDependencies[path].size) {
        delete this.pathDependencies[path];
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.sourceState;
    }
  }]);

  return ProxyStateTree;
}();